<template>
  <div
    :class="[
      'product-attributes-toggle-fi',
      isBlock ? 'product-attributes-toggle-fi--is-block' : '',
      shopType ? `product-attributes-toggle-fi--${shopType}` : '',
    ]"
  >
    <span class="product-attributes-toggle-fi__label">
      {{ $dict.get('product-List.General.Approvals-Switch') }}
    </span>
    <toggle-fi
      v-model="approvalsEnabled"
      class="product-attributes-toggle-fi__switch"
      @click="$emit('toggle-approvals')"
    />
  </div>
</template>

<script>
import { ToggleFi } from 'atoms';
import { mapGetters } from 'vuex';

export default {
  name: 'ProductAttributesToggleFi',
  components: {
    ToggleFi,
  },
  props: {
    isBlock: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['toggle-approvals'],
  computed: {
    ...mapGetters({
      shopType: 'productList/getShopType',
    }),
    approvalsEnabled: {
      get() {
        return this.$store.getters['productList/getApprovalsEnabled'];
      },
      set(state) {
        this.$store.dispatch('productList/setApprovalsEnabled', state);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import './product-attributes-toggle-fi';
</style>
